import MdxHeader from './MdxHeader';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH6 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h6"
}));
function MdxH6(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(MdxHeader, {
    Component: StyledH6,
    marginBlockStart: "1100",
    marginBlockEnd: "400",
    children: children
  });
}
export default MdxH6;